module.exports = "/images/Get more foot traffic.svg?98a0ec7e4160bfb48bfd29ba5beede20";